<template>
  <div class="d-flex lobby3 desktop" :class="jel_getClassObject(content)">
    <template v-if="isVisible && produit">
      <CarteImageInfo
        class="table lobby-table-block table-details-loaded"
        :class="produit.gameTypeUnified"
        :data-game="produit.gameTypeUnified"
        :content="getContentCarteImageInfo()"
        :afficherInfoSecondaire="true"
      >
        <template #image>
          <b-img
            v-if="produit.videoSnapshotBG"
            :src="produit.videoSnapshotBG"
            :alt="content.altImage"
            class="image-ced"
          >
          </b-img>
          <div v-else class="BIDON-TEMP">TODO: Image par défaut<br />(table fermée)</div>
        </template>

        <template #infoSecondaire>
          <!-- ref="conteneurLotProgressif" -->
          <CarteInfoSecondaireCED
            :produit="produit"
            class="lobby-table-game-specific-data"
          ></CarteInfoSecondaireCED>
        </template>
        <template #infoPrimaire>
          <CarteInfoPrimaireProduit
            :produit="produitCarteInfoPrimaireProduit"
            :cacherSurTitreCategorie="content.cacherSurTitreCategorie === 'true'"
          ></CarteInfoPrimaireProduit>
        </template>
      </CarteImageInfo>
    </template>
    <div
      v-else
      v-observe-visibility="{
        callback: visibilityChanged,
        once: true,
      }"
      class="chargement w-100 h-100"
    >
      <Carte :content="content" class="w-100">
        <b-skeleton-img no-aspect height="240px"></b-skeleton-img>

        <span v-if="produit" class="text-truncate"
          >{{ mixinProduitCasino_getTitre(false) }}...</span
        >

        <div class="row">
          <div class="col-6">
            <b-skeleton width="85%"></b-skeleton>
            <b-skeleton width="55%"></b-skeleton>
            <b-skeleton width="70%"></b-skeleton>
            <b-skeleton width="85%"></b-skeleton>
          </div>
          <div class="col-6">
            <b-skeleton type="button"></b-skeleton>
          </div>
        </div>
      </Carte>
    </div>
  </div>
</template>

<script>
import { ObserveVisibility } from 'vue-observe-visibility';

import { mapGetters } from 'vuex';
import mixinProduitCasino from '@/mixins/casino/mixinProduitCasino';

import Carte from '@/components/base/carte/Carte';
import CarteImageInfo from '@/components/base/carte/CarteImageInfo';
import CarteInfoPrimaireProduit from '@/components/casino/carte/CarteInfoPrimaireProduit';
import CarteInfoSecondaireCED from '@/components/casino/carte/CarteInfoSecondaireCED';

export default {
  name: 'CarteProduitCED',
  components: {
    Carte,
    CarteImageInfo,
    CarteInfoPrimaireProduit,
    CarteInfoSecondaireCED,
  },
  directives: {
    ObserveVisibility,
  },
  mixins: [mixinProduitCasino],
  props: {
    content: { type: Object, required: true },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      getTableInfoFromUuid: 'cedTable/getTableInfoFromUuid',
      getLienInterneFromProduit: 'cedTable/getLienInterneFromProduit',
    }),
    produit() {
      // On peut recevoir un produit complet ou uniquement son UUID
      return (
        this.content.produit ?? this.getTableInfoFromUuid(this.content.idProduit, this.$isMobile())
      );
    },
    produitCarteInfoPrimaireProduit() {
      return {
        ...this.produit,
        lienInternePageProduit: this.getLienInterneFromProduit(this.produit, 'mode=lancer'),
        categorie: this.$store.state.cedTable.categorie,
        famille: this.$store.getters['cedTable/getFamilleFromProduit'](this.produit),
      };
    },
  },
  i18n: {
    messages: {
      fr: {
        libelleDemo: 'Essayer la démo',
        libelleFavoris: 'Ajouter aux favoris',
        libelleRegles: 'Règles',
      },
      en: {
        libelleDemo: 'Try the demo',
        libelleFavoris: 'Add to favorites',
        libelleRegles: 'Rules',
      },
    },
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
    },
    getContentCarteImageInfo() {
      const nouveauContenu = { ...this.content };

      nouveauContenu.image = this.produit.image;
      nouveauContenu.image2 = this.produit.image2;
      nouveauContenu.image3 = this.produit.image3;

      // test pour centrer l'image
      nouveauContenu.idProgressif = this.produit.idProgressif;

      // Texte alternatif temporaire pour afficher les images
      const altImage = this.mixinProduitCasino_getTitre(false);
      nouveauContenu.altImage = altImage;
      nouveauContenu.altImage2 = altImage;
      nouveauContenu.altImage3 = altImage;
      nouveauContenu.positionnementImage3 = this.produit.positionnementImage3;

      const itemsMenu = {};
      let index = 0;
      // Affiche l'item de menu "démo" en fonction de desktop/mobile
      if (
        (this.$isMobile() && this.produit.demoMobile) ||
        (!this.$isMobile() && this.produit.demoInternet)
      ) {
        itemsMenu[`liensMenu${index++}`] = this.getContentDemo();
      }
      itemsMenu[`liensMenu${index++}`] = this.getContentFavoris();
      itemsMenu[`liensMenu${index}`] = this.getContentRegles();
      nouveauContenu.liensMenu = itemsMenu;
      return nouveauContenu;
    },
    getContentDemo() {
      return {
        libelle: this.$t('libelleDemo'),
        lien: this.getLienInterneFromProduit(this.produit, 'mode=demo'),
      };
    },
    getContentFavoris() {
      // TODO: À compléter
      return {
        libelle: this.$t('libelleFavoris'),
        lien: {
          field: 'lienInterne',
          lienInterne: this.produit.URLfr,
          isDejaNettoye: true,
        },
      };
    },
    getContentRegles() {
      return {
        libelle: this.$t('libelleRegles'),
        lien: this.getLienInterneFromProduit(this.produit),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.image-ced {
  max-width: 200%;
  margin-left: -50%;
}

// TODO: À retirer lorsque implémentation image par défaut
.BIDON-TEMP {
  height: 300px;
}
</style>
